// extracted by mini-css-extract-plugin
export default {"container":"BlockProcessing_container__LXpr1","fade-in":"BlockProcessing_fade-in__aUA3B","subContainer":"BlockProcessing_subContainer__N31Sr"};